/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { FormLayout, TextStyle, Link, Icon } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';

import { Field } from 'redux-form';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { RenderRadioButton2 } from 'src/components/views/common/forms/render-radio-button-2';
import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import { BREADCRUMB_PLACEMENT_OPTIONS, ELEMENTS } from 'src/constants/theme-settings';
import { BREADCRUMB_ALIGNMENT_OPTIONS_TEXT } from 'src/constants/theme-settings.jsx';
import { URL } from 'src/constants/links';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductListBreadcrumbForm extends Component<ComposedProps> {
  state = {
    isOpenedCheckout: true,
    isOpenedViewCart: true
  };

  render() {
    const { i18n, formValues } = this.props;

    const isAboveTitle =
      _.get(formValues, `setting.${ELEMENTS.COLLECTION_HEADER_BREADCRUMBS}.placement`) ===
      'above-title';
    const isEnableBreadcrumbs = _.get(
      formValues,
      `setting.${ELEMENTS.COLLECTION_HEADER_BREADCRUMBS}.isEnable`
    );

    const formattedBreadcrumbsAlignment = BREADCRUMB_ALIGNMENT_OPTIONS_TEXT.map(item => {
      return {
        ...item,
        label: i18n.translate(item.label)
      };
    });

    return (
      <FormLayout>
        <div>
          <span className="form-link">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.collectionHeaderBreadcrumb_UserGuide')}
            </TextStyle>{' '}
            <Link url={URL['CollectionBreadcrumbThemeSetting']} external>
              {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
              <Icon source={ExternalMinor} color="base" />
            </Link>
            <span style={{ color: '#2C6ECB' }}>.</span>
          </span>
        </div>

        <div className="form-section">
          <div className="form-section__item form-section__item--standard-spacing">
            <Field
              name={`setting.${ELEMENTS.COLLECTION_HEADER_BREADCRUMBS}.isEnable`}
              component={RenderToggleSwitch}
              label={i18n.translate(
                'AdminHTML.ShopifyIntegrationSettings.Form.productList_Breadcrumbs_Enable'
              )}
            />
          </div>

          {isEnableBreadcrumbs && (
            <>
              <div className="form-section__item form-section__item--standard-spacing">
                <Field
                  name={`setting.${ELEMENTS.COLLECTION_HEADER_BREADCRUMBS}.showCollectionList`}
                  component={RenderCheckbox}
                  label={i18n.translate(
                    'AdminHTML.ThemeSetting.Form.collectionHeaderBreadcrumb_Checkbox_Item1'
                  )}
                />
              </div>
              <div className="form-section__item form-section__item--medium-spacing">
                <Field
                  name={`setting.${ELEMENTS.COLLECTION_HEADER_BREADCRUMBS}.showCollectionTitle`}
                  component={RenderCheckbox}
                  label={i18n.translate(
                    'AdminHTML.ThemeSetting.Form.collectionHeaderBreadcrumb_Checkbox_Item2'
                  )}
                />
              </div>
              <div className="form-section__item form-section__item--medium-spacing">
                <Field
                  name={`setting.${ELEMENTS.COLLECTION_HEADER_BREADCRUMBS}.showPagination`}
                  component={RenderCheckbox}
                  label={i18n.translate(
                    'AdminHTML.ThemeSetting.Form.collectionHeaderBreadcrumb_Checkbox_Item3'
                  )}
                />
              </div>
              <div className="form-section__item form-section__item--standard-spacing">
                <p className="title">
                  {i18n.translate(
                    'AdminHTML.ThemeSetting.Form.collectionHeaderBreadcrumb_Placement_Label'
                  )}
                </p>
                <div
                  className="radio-button-wrapper radio-button-wrapper--no-gap radio-button-wrapper--bordered"
                  style={{ marginTop: '5px' }}>
                  {BREADCRUMB_PLACEMENT_OPTIONS.map((item, index) => (
                    <Field
                      key={index}
                      name={`setting.${ELEMENTS.COLLECTION_HEADER_BREADCRUMBS}.placement`}
                      id={item.value}
                      component={RenderRadioButton2}
                      label={i18n.translate(item.label)}
                      onChange={this.rewindPosition}
                    />
                  ))}
                </div>
              </div>

              {!isAboveTitle && (
                <div className="form-section__item form-section__item--medium-spacing">
                  <p className="title">
                    {i18n.translate(
                      'AdminHTML.ShopifyIntegrationSettings.Form.productList_Breadcrumbs_Alignment_Title'
                    )}
                  </p>
                  <div className="radio-button-wrapper radio-button-wrapper--no-gap radio-button-wrapper--no-radius-middle">
                    {formattedBreadcrumbsAlignment.map((item, index) => (
                      <Field
                        key={index}
                        name={`setting.${ELEMENTS.COLLECTION_HEADER_BREADCRUMBS}.alignment`}
                        id={item.value}
                        component={RenderRadioButton2}
                        label={item.label}
                      />
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ProductListBreadcrumbForm);
